import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIconifyComponent } from './simple-icons-iconify.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIconifyComponent ],
    exports:      [ SimpleIconsIconifyComponent ],
    bootstrap:    []
})
export class SimpleIconsIconifyModule {}
